import { IUpdateCaseExpertModel } from '../../../../interfaces/ICaseExpert';
import { useMutation } from 'react-query';
import { useZoneContext } from '../../../../contexts/useZoneContext';

export const useCaseExpertUpdateMutation = (onError?: (errorMessage: string) => void) => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (caseExpert: IUpdateCaseExpertModel) => {
            const response = await zoneApiClient.updateCaseExpert(caseExpert);

            if (!response?.httpResponse.ok) {
                throw new Error('Failed to update Case Expert');
            }

            return response;
        },
        onError(error) {
            if (error instanceof Error) {
                onError?.(error.message);
            }
        },
    });
}
    